import { faCheckCircle } from '@fortawesome/pro-duotone-svg-icons'

import customConfig from 'customConfig'
import { COLOR_SUCCESS } from '../../constants/theme'
import Popup from '../shared/popup/Popup'

const ResetSuccess = ({ onSubmit, t }) => (
  <Popup
    title={t(customConfig.youDidItLabel)}
    description={t(customConfig.passwordResetSuccessLabel)}
    icon={faCheckCircle}
    color={COLOR_SUCCESS}
    submitLabel={t(customConfig.goToLoginLabel)}
    onFormSubmit={onSubmit}
  />
)

export { ResetSuccess }
